import { Image, Box, Text, Grid, GridItem } from "@chakra-ui/react";
import AnnouncementIcon from "../../../../assets/images/AnnouncementLink.svg";
import DocumntIcon from "../../../../assets/images/DocumentLink.svg";
import EmployeeIcon from "../../../../assets/images/EmployeeLink.svg";
import DepartmentIcon from "../../../../assets/images/DepartementLink.svg";
import * as routesNames from '../../../../constants/routes';
import { MyDiv } from "./quickCard.style";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../hooks/useAuth";

const QuickCard = ({ onAnnouncementClick }: { onAnnouncementClick: any }) => {
  const { hasPermission } = useAuth();
  const navigate = useNavigate();

  return (
    <MyDiv>
      <Box className="card common_bg">
        <Text pl="12px" pt="6px" className="font-poppins text_medium">Quick Link</Text>

        <Grid className="grid_container grid_gap_sm" mt={2} px={2} py={2}>
        {hasPermission('Dashboard', 'EmployeeQuickLink') ?
            <>
              <GridItem colSpan={6}>
                <Box className="card-box" onClick={()=> navigate(routesNames.MYDEPARTMENT)}>
                  <Image src={DepartmentIcon} alt="My Department" boxSize={6} />
                  <Text mt={1} className="font-poppins text_medium text_md"> My Department</Text>
                </Box>
              </GridItem>
              <GridItem colSpan={6}>
                <Box className="card-box" onClick={()=>navigate(routesNames.HOLIDAYCALENDAR)}>
                  <Image src={DocumntIcon} alt="HolidayCard" boxSize={6} />
                  <Text mt={1} className="font-poppins text_medium text_md">Holiday Calendar</Text>
                </Box>
              </GridItem>
              <GridItem colSpan={6}>
                <Box className="card-box" onClick={()=>navigate(routesNames.LEAVEAPPLY)}>
                  <Image src={AnnouncementIcon} alt="ApplyLeave" boxSize={6} />
                  <Text mt={1} className="font-poppins text_medium text_md">Apply Leave</Text>
                </Box>
              </GridItem>
              <GridItem colSpan={6}>
                <Box className="card-box" onClick={()=>navigate(routesNames.LEAVEBALANCES)}>
                  <Image src={EmployeeIcon} alt="LeaveBalance" boxSize={6} />
                  <Text mt={1} className="font-poppins text_medium text_md">Leave Balance</Text>
                </Box>
              </GridItem>
            </>
          :
          <>
          <GridItem colSpan={6}>
            <Box className="card-box" onClick={()=>navigate(routesNames.ADMINDEPARTMENT)}>
              <Image src={DepartmentIcon} alt="Department" boxSize={6} />
              <Text mt={1} className="font-poppins text_medium text_md">Department</Text>
            </Box>
          </GridItem>
          <GridItem colSpan={6}>
            <Box className="card-box" onClick={()=>navigate(routesNames.PAYROLL)}>
              <Image src={DocumntIcon} alt="Payroll" boxSize={6} />
              <Text mt={1} className="font-poppins text_medium text_md">Payroll</Text>
            </Box>
          </GridItem>
          <GridItem colSpan={6}>
            <Box className="card-box" onClick={onAnnouncementClick}>
              <Image src={AnnouncementIcon} alt="Announcement" boxSize={6} />
              <Text mt={1} className="font-poppins text_medium text_md">Announcement</Text>
            </Box>
          </GridItem>
          <GridItem colSpan={6}>
            <Box className="card-box" onClick={()=>navigate(routesNames.EMPLOYEES)}>
              <Image src={EmployeeIcon} alt="Department" boxSize={6} />
              <Text mt={1} className="font-poppins text_medium text_md">Employees</Text>
            </Box>
          </GridItem>
          </>
      }          
          <GridItem colSpan={6}>
            <Box className="card-box" onClick={()=>navigate(routesNames.CURRENTJOBOPENINGS)}>
              <Image src={EmployeeIcon} alt="Department" boxSize={6} />
              <Text mt={1} className="font-poppins text_medium text_md">Referral</Text>
            </Box>
          </GridItem>

          <GridItem colSpan={6}>
            <Box className="card-box" onClick={()=>navigate(routesNames.RESIGNATION)}>
              <Image src={EmployeeIcon} alt="Department" boxSize={6} />
              <Text mt={1} className="font-poppins text_medium text_md" fontSize="9.65px">Resignation</Text>
            </Box>
          </GridItem>
        </Grid>
      </Box>
    </MyDiv>
  );
};

export default QuickCard;
